import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {TrainingRoomPcMapping} from "@models";
import {NotificationService, SimSystemExtendedService} from "@services";

export interface TRAINING_ROOM_PC_MAPPING_CONFIGURATION_DIALOG_INPUT extends MatDialogDataBaseInput {
	trainingRoomPcMapping: TrainingRoomPcMapping;
}

export interface TRAINING_ROOM_PC_MAPPING_CONFIGURATION_DIALOG_OUTPUT extends MatDialogDataBaseOutput {
	updatedTrainingRoomPcMapping: TrainingRoomPcMapping;
}

@Component({
	selector: "sim-training-room-pc-mapping-configuration-dialog",
	templateUrl: "./training-room-pc-mapping-configuration-dialog.component.html",
	styleUrls: ["./training-room-pc-mapping-configuration-dialog.component.scss"],
	standalone: false,
})
export class TrainingRoomPcMappingConfigurationDialogComponent
	extends BasicMaterialDialog<
		TrainingRoomPcMappingConfigurationDialogComponent,
		TRAINING_ROOM_PC_MAPPING_CONFIGURATION_DIALOG_INPUT,
		TRAINING_ROOM_PC_MAPPING_CONFIGURATION_DIALOG_OUTPUT
	>
	implements OnInit
{
	hidePassword = true;

	constructor(
		private _simSystemService: SimSystemExtendedService,
		private _simNotificationService: NotificationService,
		_injector: Injector,
	) {
		super(_injector);
	}

	public async findMacAddressForViewingStation(ip: string) {
		if (!ip) {
			return;
		}
		const macAddressResult = await this._simSystemService.getMacAddress(ip);
		if (macAddressResult) {
			this.data.trainingRoomPcMapping.macAddress = macAddressResult;
		} else {
			this._simNotificationService.notifyError("Could not find a MAC address for the given IP address.");
		}
	}

	public saveViewingStationMapping() {
		this.close({
			action: "ok",
			updatedTrainingRoomPcMapping: this.data.trainingRoomPcMapping,
		});
	}
}
